import type { ReactNode } from 'react';

import { Box } from '@zillow/constellation-10';

import ParticipantContainer from './ParticipantContainer';
import WhoHasSigned from '../Widgets/WhoHasSigned';
import ColandlordLeaseStatus from './ColandlordContentContainer/ColandlordLeaseStatus';
import ColandlordFaq from './ColandlordContentContainer/ColandlordFaq';
import { useLeaseFromOuidQuery } from '../../utils/queries';

type Props = {
  children?: ReactNode;
};

export function ColandlordContentContainer({ children }: Props) {
  const queryParams = new URLSearchParams(window.location.search);
  const ouid = queryParams.get('ouid');

  const leaseQuery = useLeaseFromOuidQuery(ouid, !!ouid);
  const lease = leaseQuery.data;

  const rightSidebarContent = (
    <ColandlordFaq explainerLeaseName={null} isLoading={leaseQuery.isLoading}>
      {!leaseQuery.isError && ouid && <ColandlordLeaseStatus lease={lease} />}
      {lease?.showWhoHasSigned() && (
        <Box css={{ marginBottom: 'tight' }}>
          <WhoHasSigned leaseId={lease.id} isInitiallyExpanded usesOuid />
        </Box>
      )}
    </ColandlordFaq>
  );

  return <ParticipantContainer rightSidebarContent={rightSidebarContent}>{children}</ParticipantContainer>;
}

export default ColandlordContentContainer;
